import { apiClient } from "@/services/apiClient";

export interface SalesReportSummary {
  totalUyu: number;
  totalUsd: number;
  invoiceCount: number;
}

export interface SalesReportData {
  dateFrom: string;
  dateTo: string;
  summary: SalesReportSummary;
  previousPeriodSummary: SalesReportSummary | null;
  previousPeriodDateFrom: string | null;
  previousPeriodDateTo: string | null;
  revenueBreakdown: {
    grossUyu: number;
    grossUsd: number;
    creditNotesUyu: number;
    creditNotesUsd: number;
    netUyu: number;
    netUsd: number;
    subtotalUyu: number;
    subtotalUsd: number;
    ivaUyu: number;
    ivaUsd: number;
    creditNoteCount: number;
    baseInvoiceCount: number;
    avgTicketUyu: number;
    avgTicketUsd: number;
    creditNoteRatio: number;
  };
  clientMetrics: {
    totalClients: number;
    newClients: number;
    returningClients: number;
  };
  byCfeType: Array<{
    cfeType: string;
    cfeTypeLabel: string;
    totalUyu: number;
    totalUsd: number;
    invoiceCount: number;
  }>;
  byClient: Array<{
    clientName: string;
    clientDisplayName: string | null;
    clientRut: string | null;
    clientDocRecepExt: string | null;
    totalUyu: number;
    totalUsd: number;
    invoiceCount: number;
  }>;
  topProducts: Array<{
    description: string;
    totalUyu: number;
    totalUsd: number;
    quantity: number;
  }>;
  monthlyBreakdown: Array<{
    month: string;
    totalUyu: number;
    totalUsd: number;
    invoiceCount: number;
  }>;
}

export function getSalesReport(
  dateFrom: string,
  dateTo: string,
): Promise<SalesReportData> {
  return apiClient
    .get<SalesReportData>("/reports/sales", { params: { dateFrom, dateTo } })
    .then((res) => res.data);
}

export async function downloadSalesCsv(
  dateFrom: string,
  dateTo: string,
): Promise<void> {
  const res = await apiClient.get("/reports/sales/csv", {
    params: { dateFrom, dateTo },
    responseType: "blob",
  });
  const disposition = res.headers["content-disposition"] ?? "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match?.[1] ?? `ventas_${dateFrom}_${dateTo}.csv`;
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
    a.remove();
  }, 100);
}
